// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file search/search_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file search/search_requests.proto.
 */
export const file_search_search_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChxzZWFyY2gvc2VhcmNoX3JlcXVlc3RzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJiChNHbG9iYWxTZWFyY2hSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEhMKBmN1cnNvchgCIAEoCUgAiAEBEhIKBWxpbWl0GAMgASgFSAGIAQFCCQoHX2N1cnNvckIICgZfbGltaXRCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.GlobalSearchRequest
 */
export type GlobalSearchRequest = Message<'com.gem.bff.contract.GlobalSearchRequest'> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.GlobalSearchRequest.
 * Use `create(GlobalSearchRequestSchema)` to create a new message.
 */
export const GlobalSearchRequestSchema: GenMessage<GlobalSearchRequest> =
  /*@__PURE__*/
  messageDesc(file_search_search_requests, 0);
